import { AxiosResponse } from 'axios';

import { ApiVersion } from '@/config';
import { IDynamicFormTypes, IOffenseOptionResponse } from '@/models';

import { http } from './http';

export const ConfigOptionsApi = {
  getConfigOptions: async (
    optionType: string,
  ): Promise<AxiosResponse<IOffenseOptionResponse[]>> => {
    return http.get(
      `api/${ApiVersion.V1}/config-options/get_config_file?optionType=${optionType}`,
    );
  },
  getFormConfig: async (
    formType: IDynamicFormTypes,
  ): Promise<AxiosResponse<any[]>> => {
    return http.get(
      `api/${ApiVersion.V1}/config-options/get_config_file?formType=${formType}`,
    );
  },
  getFileVersion: async (
    optionName: string,
    fileType: 'optionType' | 'formType',
  ): Promise<AxiosResponse<number>> => {
    return http.get(
      `api/${ApiVersion.V1}/config-options/get_config_version?${fileType}=${optionName}`,
    );
  },
};
